import { Fragment } from "react"
import { cn } from "~/utils/helpers"

interface KeyboardShortcutProps {
  keys: string | string[]
  sequence?: boolean
  label?: string
  className?: string
}

export function KeyboardShortcut({ keys, sequence, label, className }: KeyboardShortcutProps) {
  const keyArray = Array.isArray(keys) ? keys : [keys]

  return (
    <div className={cn("flex flex-row gap-1 items-center", className)}>
      {label && <div className="text-xs text-fg-muted">{label}</div>}
      {keyArray.map((key, index) => (
        <Fragment key={index}>
          {sequence && index > 0 && <span className="text-xs text-fg-muted">then</span>}
          <div className="flex justify-center items-center h-4 px-0.5 bg-base label-base rounded-sm shadow-base text-fg-subtle text-xs">
            {key}
          </div>
        </Fragment>
      ))}
    </div>
  )
}
